import { I18N } from "aurelia-i18n";
import { autoinject } from "aurelia-framework";
import { Router } from "aurelia-router";
import { AuthService } from "../services/auth";

@autoinject
export class MainNavBar {
  constructor(
    private router: Router,
    private i18n: I18N,
    private authService: AuthService,
  ) {}

  setLanguage(lang: string) {
    this.i18n.setLocale(lang).then(() => (location.search = `lang=${lang}`));
  }

  getLanguages(): string[] {
    let languages = this.i18n.tr("language", { returnObjects: true });
    return Object.keys(languages);
  }

  getCurrentLanguage(): string {
    return this.i18n.getLocale().split("-")[0];
  }

  getLanguageIcon(locale: string): string {
    return `img/language-icons/${locale}.svg`;
  }

  get authuserFullname(): string {
    return this.authService.isAuthenticated()
      ? this.authService.getTokenPayload().fullname ||
          this.authService.getTokenPayload().sub
      : undefined;
  }

  get authenticated(): boolean {
    return this.authService.isAuthenticated();
  }

  logout() {
    this.authService.logout();
  }

  get changePasswordEnabled(): boolean {
    return this.authService.hasRightOneOf(["change-password"]);
  }

  changePassword() {
    this.router.navigateToRoute("changePassword");
  }
}
